<template>
  <div class="login-page">
    <q-card class="my-card">
        <q-card-section class="card-section">
          <div class="card-title">User Panel</div>
        </q-card-section>
      <q-separator />
  
      <q-card-section class="card-content">
        <div class="welcome-user">Welcome <b>{{ user.UserID }}</b> to {{ appName }}</div>
        <div class="logout" @click="$emit('logout')">[Logout]</div>
        <div class="field">
          <div class="point-details">
            <div class="column">
              <div>
                <p>E-Points</p>
              </div>
              <div>
                <p>GT-Points</p>
              </div>
              <div v-if="Number(user.UserType) === 3">
                <p>Earned Commision</p>
              </div>
            </div>
            <div class="column">
              <div>
                <p>{{ user.UserPoint }}</p>
              </div>
              <div>
                <p>{{ user.VotePoint }}</p>
              </div>
              <div v-if="Number(user.UserType) === 3">
                <p>{{ user.commision }}</p>
              </div>
            </div>
          </div>
          
          <div v-if="referralLink" class="referral-link" @click="copyReferralLink">
            <p>{{ referralLink }}</p>
          </div>
          <q-list padding class="rounded-borders text-primary">
            <q-item
              v-for="feature in getModulesNormal"
              :key="feature.ID"
              @click="$emit('action', feature)"
              clickable
              v-ripple
              color="text-orange"
            >
              <q-item-section >
                <q-item-label style="color: white">{{ feature.Name }}</q-item-label>
              </q-item-section>
            </q-item>
            
            <q-expansion-item
              expand-separator
              icon="person"
              label="Admin Panel"
              v-if="getModulesAdmin.length"
            >
              <q-item
                v-for="feature in getModulesAdmin"
                :key="feature.ID"
                @click="$emit('action', feature)"
                clickable
                v-ripple
                color="text-orange"
              >
                <q-item-section >
                  <q-item-label style="color: white">{{ feature.Name }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-expansion-item>
          </q-list>
        </div>
      </q-card-section>
    </q-card>
  </div>
  </template>
  <script>
  import { mapGetters, mapActions } from 'vuex';
  import { useVuelidate } from '@vuelidate/core'
    import { copyToClipboard } from 'quasar'
  
  export default {
    setup () {
      return { v$: useVuelidate() }
    },
    name: 'UserPanel',
    data () {
      return {
      }
    },
    computed: {
      ...mapGetters({
        user: 'user/getUser',
        characters: 'user/getCharacters',
        getModulesAdmin: 'panel/getModulesAdmin',
        getModulesNormal: 'panel/getModulesNormal'
      }),
      appName () {
        return process.env.VUE_APP_RAN_NAME
      },
      isAdmin () {
        return Number(this.user.UserType) >= 30
      }
    },
    async created () {
      this.$q.loading.show()

      await this.requestUserPanel()

      this.$q.loading.hide()
    },
    methods: {
      ...mapActions({
        requestUserPanel: 'panel/requestUserPanel'
      }),
      copyReferralLink () {
        copyToClipboard(this.referralLink)
          .then(() => {
            this.$q.notify({
              position: 'top-right',
              message: 'Copied',
              type: 'positive'
            })
          })
          .catch(() => {
            this.$q.notify({
              position: 'top-right',
              message: 'Error in copyinh',
              type: 'negative'
            })
          })
      }
    }
  }
  </script>
  
  <style lang="scss">
  .login-page {
    .my-card {
      background-color: $backgroundHeader;

      .card-title {
        font-size: 16px;
        font-weight: 700;
      }
      .card-section {
        color: white;
      }
      .card-content {
        background-color: $background;
  
        .welcome-user {
          font-size: 16px;
          font-weight: 400;
          color: white;
        }

        .logout {
          font-size: 14px;
          font-weight: 400;
          color: blue;
          cursor: pointer;
        }
  
        .field {
          padding: 16px;
          gap: 10px;

          .point-details {
            padding: 0px;
            display: flex;

            .column {
              float: left;
              width: 50%;
              text-align: left;
              color: white;

              p {
                border: solid 1px;
                margin: 0;
                padding: 8px;
              }

              .starting-bid {
                white-space: nowrap;
                color: white;
                font-size: 16px;
                font-weight: 700;
              }
            }
          }

          .referral-link {
            cursor: pointer;
            font-size: 14px;
            border: solid 1px;
            border-color: white;

            p {
              color: blue;
              padding: 5px;
              margin: 0;
            }
          }
        }
      }
      
    }
  }
  </style>